<rt-infobox [isDismissible]="false" type="warning" iconName="warning">
  <div layout layout-space-between>
    <div layout-vertical padding-right-medium>
      <span text-bold>
        {{ 'app.offers.switch_editors_infobox.title' | translate }}
      </span>
      <ul [innerHTML]="'app.offers.switch_editors_infobox.message_v2' | translate" no-margin></ul>
    </div>
    <rt-button variant="outline-warning" size="small" (click)="onSwitchEditorsClick()">
      {{ 'app.offers.switch_editors_infobox.button_label' | translate }}
    </rt-button>
  </div>
</rt-infobox>
